import TableCustomized from "../../../common/components/TableCustomized";
import PaperCustomized from "../../../common/components/PaperCustomized";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useEffect, useState } from "react";
import {
  formattedDateFromDB,
  formattedDateTimeFromDB,
} from "../../../common/utils/FunctionsUtils";
import { useDispatch } from "react-redux";
import { IconButton } from "@mui/material";
import { downloadTiDocument } from "../state/TiActions";

function ListReglamentation(props) {
  const dispatch = useDispatch();

  const [factures, setFactures] = useState([]);
  const [numRegistre, setNumRegistre] = useState(null);

  const columns = [
    {
      field: "montant",
      headerName: "Montant",
      flex: 0.7,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "devise",
      headerName: "Devise",
      flex: 0.7,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "date",
      headerName: "Date",
      flex: 0.7,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "typeReg",
      headerName: "Type du règlement",
      flex: 1,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "numFormule",
      headerName: "Numéro de la formule",
      flex: 1,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "modeReg",
      headerName: "Mode du règlement",
      flex: 1,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
  ];

  const rows = [];
  props?.detail?.donneeReglamentationDtos?.map((row, index) => {
    rows.push({
      id: row.id,
      date: formattedDateFromDB(row.dateApplication),
      montant: row.quantite,
      devise: row.devise?.description,
      typeReg: row.typeReglement?.description,
      numFormule: row.formule,
      modeReg: row.modalitePaiement?.description,
    });
  });

  return (
    <PaperCustomized
      title={"Suivi des données relatives aux règlements"}
      forActions={false}
    >
      <TableCustomized
        columns={columns}
        rows={rows}
        totalElements={rows?.length}
        pageSizeOptions={[10, 25, 50, 100]}
        paginationMode="client"
        isSlots={false}
        isFooter={true}
        noDataHeight="120px"
        cursor="auto"
      />
    </PaperCustomized>
  );
}

export default ListReglamentation;
